import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { labelsToUrl } from "../Api/../Prelude.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { map, length, isEmpty, ofArray, empty, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { createElement } from "react";
import React from "react";
import { adminContent, ByCell, dateTimeCell, Labels, EntityName } from "./Prelude.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { append, empty as empty_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/ProductionUnits.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Create, MoveToType } from "../Modals/ProductionUnit.fs.js";
import { Components_UnDelete, Components_Delete, Components_ChangeAttributes, Components_ChangeLabels } from "../Modals/Modal.fs.js";
import { Entity, DomainEntity } from "../ClientTypes.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function labelParam(key, value) {
    if (isNullOrWhiteSpace(key) && isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["labels"]);
    }
    else {
        return new FSharpResult$2(0, [["labels", labelsToUrl(ofList(singleton([key, ofList_1(singleton(value), {
            Compare: comparePrimitives,
        })]), {
            Compare: comparePrimitives,
        }))]]);
    }
}

function columns(projectId) {
    return ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("detail", "Detail", undefined), new Column("productionUnitType", "Production Unit Type", undefined), new Column("labels", "Labels", new FilterType(2, [projectId, new DomainEntities(13, []), empty(), (tupledArg) => labelParam(tupledArg[0], tupledArg[1])])), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);
}

function rowRender(projectId, productionUnit) {
    return new Row(productionUnit.Id, ofArray([new Cell("name", productionUnit.Name), new Cell("detail", productionUnit.Detail), new Cell("productionUnitType", createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(14, []),
        entityId: productionUnit.ProductionUnitTypeId,
    })), new Cell("labels", createElement(Labels, {
        labels: productionUnit.Labels,
    })), new Cell("lastModifiedOn", dateTimeCell(productionUnit.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: productionUnit.LastModifiedBy,
    }))]));
}

export function ProductionUnits(productionUnitsInputProps) {
    let actions, productionUnits, productionUnits_1;
    const projectId = productionUnitsInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedProductionUnits = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    let columns_1;
    const dependencies_1 = [projectId];
    columns_1 = reactApi.useMemo(() => columns(projectId), dependencies_1);
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Production Units",
        columns: columns_1,
        initialFilters: toList(delay(() => (showDeleted ? singleton_1(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (productionUnitTypeParams) => many(projectId, empty(), productionUnitTypeParams),
        fetchCount: (productionUnitTypeParams_1) => count(projectId, productionUnitTypeParams_1),
        rowRender: (productionUnit) => rowRender(projectId, productionUnit),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedProductionUnits);
    const isMoreThan1 = length(selectedProductionUnits) !== 1;
    return adminContent(toList(delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Type"], ["onClick", (_arg_2) => {
        setAction("moveToType");
    }], ["disabled", isEmpty(selectedProductionUnits) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Labels"], ["onClick", (_arg_3) => {
        setAction("changeLabels");
    }], ["disabled", isEmpty(selectedProductionUnits) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Attributes"], ["onClick", (_arg_4) => {
        setAction("changeAttributes");
    }], ["disabled", isEmpty(selectedProductionUnits) ? true : showDeleted]]))))), delay(() => (showDeleted ? singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_5) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedProductionUnits)]]))))) : singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_6) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedProductionUnits)]])))))))))))))))))), table, (action != null) ? ((actions = action, (actions === "moveToType") ? createElement(MoveToType, {
        projectId: projectId,
        productionUnits: selectedProductionUnits,
        close: close,
    }) : ((actions === "changeLabels") ? createElement(Components_ChangeLabels, {
        projectId: projectId,
        entities: map((productionUnit_1) => [new DomainEntity(5, [productionUnit_1]), productionUnit_1.Labels], selectedProductionUnits),
        close: close,
    }) : ((actions === "changeAttributes") ? createElement(Components_ChangeAttributes, {
        projectId: projectId,
        entities: map((productionUnit_2) => [new Entity(4, [productionUnit_2]), productionUnit_2.Attributes], selectedProductionUnits),
        close: close,
    }) : ((actions === "delete") ? ((productionUnits = map((Item) => (new DomainEntity(5, [Item])), selectedProductionUnits), createElement(Components_Delete, {
        projectId: projectId,
        entities: productionUnits,
        close: close,
    }))) : ((actions === "unDelete") ? ((productionUnits_1 = map((Item_1) => (new DomainEntity(5, [Item_1])), selectedProductionUnits), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: productionUnits_1,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    }))))))) : undefined);
}

